import { render, staticRenderFns } from "./answers-owners.vue?vue&type=template&id=8a420b5e"
import script from "./answers-owners.vue?vue&type=script&lang=js"
export * from "./answers-owners.vue?vue&type=script&lang=js"
import style0 from "./answers-owners.vue?vue&type=style&index=0&id=8a420b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports